var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m.667 23.653 10-10.013L16 18.973l9.454-10.626 1.88 1.88L16 22.973l-5.333-5.333-8 8.013-2-2Zm2-6 8-8.013L16 14.973 27.334 2.227l-1.88-1.88L16 10.973 10.667 5.64l-10 10.013 2 2Z"
})));
export default SvgDoubleLine;